import React, { useState, useEffect } from 'react';
import { useAuthContext } from '../hooks/auth';
import { useUserInfo } from '../hooks/user-info';
import { ErrorText } from './global.styles';
import { Loading } from './loading';
export const AuthenticatedAccess = (props) => {
    const [loading, setLoading] = useState(true);
    const { authToken } = useAuthContext();
    const { userInfoFetching, userInfoError, userInfoData, getUserInfo } = useUserInfo();
    const { children, authError, configError } = props;
    useEffect(() => {
        if (authToken) {
            getUserInfo().catch((e) => {
                console.error(`Unexpected error in getUserInfo function in AuthenticatedAccess component in support tool web app: ${e.message}`);
            });
        }
    }, [authToken]);
    useEffect(() => {
        if (userInfoData)
            setLoading(false);
    }, [userInfoData]);
    if (configError)
        return React.createElement(ErrorText, null,
            "Config Error: ",
            configError.message);
    if (authError)
        return React.createElement(ErrorText, null,
            "Auth Error: ",
            authError.message);
    if (userInfoError)
        return React.createElement(ErrorText, null,
            "User Info Error: ",
            userInfoError.message);
    return React.createElement(React.Fragment, null, loading || userInfoFetching ? React.createElement(Loading, null) : children);
};
//# sourceMappingURL=authenticated-access.js.map